import { isArrayEmpty } from "../../omnia"
import { State } from "../state"
import { FieldGroups } from "./fields/Fields"
import { Filters } from "./filters/Filters"
import { Footer } from "./Footer"
import { LayerTypeSelector } from "./LayerTypeSelector"
import { LayerViewerOptions } from "./LayerViewerOptions"
import { SetParameters } from "./parameters/SetParameters"

interface Props {
    state: State
}

export function Form({ state }: Props) {

    const { type, layerType, selection, visibleLayers } = state
    const { layerTypes } = selection

    const hasVisibleLayers = !isArrayEmpty(visibleLayers)

    const parameters = type === "setParameters"
        ? state.parameters
        : undefined

    return <form className="form omnia-form material-form" autoComplete="off" noValidate={true}>

        <div className="content">

            <Filters state={state} />

            <LayerTypeSelector layerTypes={layerTypes} layerType={layerType} />

            {
                hasVisibleLayers &&
                <LayerViewerOptions options={state.layerViewerOptions} />
            }

            <FieldGroups state={state} />

            <SetParameters parameters={parameters} />

        </div>

        <Footer state={state} />

    </form>

}
